import { useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';
import { usePostHog } from '@posthog/react';

import { AppContext } from '../../context.js';

import Helmet from "../components/helmet.js";
import { Button } from '../components/component.js';

function Feedback() {
  const context = useContext(AppContext);
  const posthog = usePostHog();
  const navigate = useNavigate();

  const [message, setMessage] = useState("");

  const [sent, setSent] = useState(false);

  function send() {
    if (!message.trim()) {
      return;
    }

    let u = context.addSpiner();
    axios.post('/api/admin/physicians/feedback', {
      message: message
    }).then((response) => {
      posthog?.capture('feedback_submitted');
      setMessage("");
      setSent(true);
    }).catch((e) => {
      posthog?.capture('feedback_submit_failed', {
        status: e?.response?.status ?? 0,
        code: e?.response?.data?.code ?? null,
      });
      context.addError(e);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (sent) {
    return (
      <>
        <Helmet title="Feedback Sent" />

        <div className="container">

          <div className="row mb-4">
            <div className="col-xs-12 col-lg-offset-2 col-lg-8">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="typo-hero-small">Thank you for your feedback!</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </>
    );
  }

  return (
    <>
      <Helmet title="Feedback" />

      <div className="container">

        <div className="row mb-4">
          <div className="col-xs-8 col-xs-offset-2">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center">
                <span className="typo-hero-small">Feedback Form</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mb-4">
          <div className="col-xs-8 col-xs-offset-2">
            <div className="card">
              {/* <div className="card-header sm">
                <div className="typo-strong-300">Share your thoughts</div>
              </div> */}
              <div className="card-content sm">
                <textarea
                  placeholder="Please share your feedback, suggestions, or report any issues..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="input borderless typo-normal-175 w-100"
                  rows="10"
                  style={{resize: 'vertical', minHeight: '200px'}}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-xs-8 col-xs-offset-2 text-end">
            <Button onClick={send} color="blue" text="Send Feedback" />
          </div>
        </div>
       
      </div>
    </>
  );
}

export default Feedback;

